import type { FlowContext, Step } from '@/types'

function withMergeMeta(step: Step, mergeKey: string, mergePriority = 0): Step {
  return {
    ...step,
    mergeKey,
    mergePriority,
  }
}

export const isPhysicallyActive = (ctx: FlowContext): boolean => {
  const frequency = ctx.vars.frequencia_atividade_fisica
  return typeof frequency === 'string' && frequency !== 'nao_pratico'
}

export const hasAdequateHydration = (ctx: FlowContext): boolean => {
  return ctx.vars.consumo_agua === '2_3l' || ctx.vars.consumo_agua === 'mais_3l'
}

export const sharedProteinIntakeStep = withMergeMeta(
  {
    id: 'protein_intake',
    type: 'choice',
    inputKey: 'consumo_proteina',
    content: 'Você consome proteína regularmente (carnes, ovos, leguminosas)?',
    options: [
      { label: 'Sim, em todas as refeições principais', value: 'sim' },
      { label: 'Às vezes', value: 'as_vezes' },
      { label: 'Raramente', value: 'raramente' },
      { label: 'Sou vegetariano/vegano', value: 'vegetariano' },
    ],
  },
  'lifestyle.protein_intake',
  100,
)

export const sharedWaterIntakeStep = withMergeMeta(
  {
    id: 'water_intake',
    type: 'choice',
    inputKey: 'consumo_agua',
    content: 'Quanto de água você bebe por dia?',
    options: [
      { label: 'Menos de 1 litro', value: 'menos_1l' },
      { label: 'Entre 1 e 2 litros', value: '1_2l' },
      { label: 'Entre 2 e 3 litros', value: '2_3l' },
      { label: 'Mais de 3 litros', value: 'mais_3l' },
    ],
  },
  'lifestyle.water_intake',
  100,
)

export const sharedActivityFrequencyStep = withMergeMeta(
  {
    id: 'activity_frequency',
    type: 'choice',
    inputKey: 'frequencia_atividade_fisica',
    content: 'Você pratica atividade física regularmente?',
    options: [
      { label: 'Não pratico', value: 'nao_pratico' },
      { label: '1-2 vezes por semana', value: '1_2_semana' },
      { label: '3-4 vezes por semana', value: '3_4_semana' },
      { label: '5 ou mais vezes por semana', value: '5_mais_semana' },
    ],
  },
  'lifestyle.activity_frequency',
  100,
)

export const sharedSleepQualityStep = withMergeMeta(
  {
    id: 'sleep_quality',
    type: 'choice',
    inputKey: 'qualidade_sono',
    content: 'Como está a qualidade do seu sono?',
    options: [
      { label: 'Boa (durmo bem)', value: 'boa' },
      { label: 'Regular', value: 'regular' },
      { label: 'Ruim (insônia, sono leve)', value: 'ruim' },
    ],
  },
  'lifestyle.sleep_quality',
  100,
)

export const sharedStressLevelStep = withMergeMeta(
  {
    id: 'stress_level',
    type: 'choice',
    inputKey: 'nivel_estresse',
    content: 'Qual seu nível de estresse atualmente?',
    options: [
      { label: 'Baixo', value: 'baixo' },
      { label: 'Moderado', value: 'moderado' },
      { label: 'Alto', value: 'alto' },
      { label: 'Muito alto', value: 'muito_alto' },
    ],
  },
  'lifestyle.stress_level',
  100,
)

export const sharedPregnancyStatusStep = withMergeMeta(
  {
    id: 'pregnancy_status',
    type: 'choice',
    inputKey: 'gestante_amamentando',
    content: 'Você está gestante ou amamentando atualmente?',
    options: [
      { label: 'Gestante', value: 'gestante' },
      { label: 'Amamentando', value: 'amamentando' },
      { label: 'Não', value: 'nao' },
    ],
  },
  'clinical.pregnancy_status',
  100,
)
